/**
 * Get date time string in the format of YYYY-MM-DD HH:MM:SS from timestamp.
 *
 * @param  {string}  timestamp
 * @return {string}
 */
export function getDateTimeFromTimestamp(timestamp) {
  return timestamp ? new Date(timestamp).toLocaleString() : '';
}

export function getDateFromTimestamp(timestamp) {
  return timestamp ? new Date(timestamp).toLocaleDateString() : '';
}

/**
 * Get date time string in the format of HH:MMp | YY-MM-DD from timestamp.
 *
 * @param  {string}  timestamp
 * @return {string}
 */
export function getDateTimeFromTimestampAltFromat(timestamp) {
  if (!timestamp) {
    return '';
  }

  let date = new Date(timestamp * 1000);

  return `${date.toLocaleString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  })} | ${date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  })}`;
}

export const getTimeIntervalText = (pastTime) => {
  const currentTime = new Date().getTime();
  const previousTime = pastTime.getTime();

  const seconds = Math.floor((currentTime - previousTime) / 1000);

  let text = '';

  switch (true) {
    case seconds > 86400:
      text = 'Updated more than a day ago';
      break;
    case seconds > 3600 && seconds < 86400:
      const hour = Math.floor(seconds / 60);
      text = `Updated more than ${hour} hours ago`;
      break;
    case seconds > 120 && seconds < 3600:
      const minutes = Math.floor(seconds / 60);
      text = `Updated more than ${minutes} minutes ago`;
      break;
    case seconds < 120:
      text = 'Recently updated';
      break;
    default:
      text = 'Recently updated';
      break;
  }

  return text;
};
